import FileGalleryContainer from './FileGalleryContainer'
export { FileGalleryContainer }
export default FileGalleryContainer



// WEBPACK FOOTER //
// ./src/components/FileGallery/index.js